import React, { createContext, useContext, useReducer } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';


const AuthContext = createContext();
const storedToken = localStorage.getItem('accessToken');

const initialState = {
  isAuthenticated: !!storedToken,
  userData: null,
  accessToken: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
    case 'SIGNUP':
    case 'OTP':
      return {
        ...state,
        accessToken: null
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        userData: null,
        accessToken: null,
      };
    case 'SET_USER':
      return {
        ...state,
        userData: action.payload,
        isAuthenticated: true,
      };
    case 'SET_TOKEN':
      return {
        ...state,
        accessToken: action.payload,
        isAuthenticated: true,
      };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  let { isAuthenticated, userData, accessToken } = state;


  const setAuthState = (newAuthState) => {
    dispatch({ type: newAuthState ? 'LOGIN' : 'LOGOUT' });
  };

  const setUser = (newUserData) => {
    dispatch({ type: 'SET_USER', payload: newUserData });
  };

  const setToken = (newToken) => {
    dispatch({ type: 'SET_TOKEN', payload: newToken });
  };


  const login = async (loginData) => {
    try {
      const response = await axios.post(
        'https://sydney-backend.vercel.app/auth/v1/login',
        { payload: loginData },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {

        console.log('Login successful!');

        if (response.data.error === null) {
          toast.success('Login successful!', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });

          const { data: { user } } = response.data;

          const { id, email } = user;

          const constructedUserData = {
            id,
            email,
          };

          setUser(constructedUserData);
          setToken(response.data.data.session.access_token);
          localStorage.setItem('accessToken', response.data.data.session.access_token);
          localStorage.setItem('profile_id', response.data.data.user.id);
          localStorage.setItem('email', email);
          localStorage.setItem('refreshToken', response.data.data.session.refresh_token);
          localStorage.setItem('exDate', response.data.data.session.expires_in);

          return true;
        }
        else {
          toast.error(response.data.error.message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
          return false;
        }
      }
    } catch (error) {
      console.error('Error logging in:', error);
      return false;
    }
  };

  const signup = async (userData) => {
    console.log('Data to send to the backend:', userData);
    try {
      const response = await axios.post(
        'https://sydney-backend.vercel.app/auth/v1/signup',
        { payload: userData },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      const { data: { user }, returnedUser } = response.data;

      if (response.status === 200) {
        console.log(response);

        if (response.data.error === null) {
          toast.success('Check your email to verify the account', {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });

          const { id, email } = user;
          const { data: userDataArray } = returnedUser;
          const { first_name, last_name } = userDataArray[0];

          const constructedUserData = {
            id,
            email,
            first_name,
            last_name
          };

          setAuthState(true);
          setUser(constructedUserData);
          return true;
        }

        else {
          toast.error(response.data.error.message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
          return false;
        }

      } else {
        console.error('Signup failed.');
      }
    } catch (error) {
      console.error('Error signing up:', error);
    }
  };



  const signout = async () => {

    const response = axios.post(
      'https://sydney-backend.vercel.app/auth/v1/signout',
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      }
    );


    localStorage.clear();
    setAuthState(false);


  };

  const checkotp = async (email, type, otpCode) => {
    try {
      const response = await axios.post(
        'https://sydney-backend.vercel.app/auth/v1/otp',
        {
          payload: {
            email,
            type,
            otp_code: otpCode
          }
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {

        if (response.data.error === null) {
          console.log(response);
          console.log('otp sent successfully!');
          dispatch({ type: 'OTP' });
          localStorage.setItem('accessToken', response.data.data.session.access_token);
          setToken(response.data.data.session.access_token);
          setAuthState(true);
          return true;
        }

        else {
          dispatch({ type: 'LOGOUT' });
          toast.error(response.data.error.message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        }


      } else {
        console.error('Error sending confirmation email:', response);
      }
    } catch (error) {
      console.error('Error sending otp:', error);
    }
  };

  const sendConfirmationEmail = async (email) => {
    try {
      const response = await axios.post(
        'https://sydney-backend.vercel.app/auth/v1/reset',
        { payload: email },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {

        if (response.data.error === null) {
          console.log(response)
          console.log('Confirmation email sent successfully!');
        }

        else {
          toast.error(response.data.error.message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        }
      } else {
        console.error('Error sending confirmation email:', response.data);
      }
    } catch (error) {
      console.error('Error sending confirmation email:', error);
    }
  };

  const setNewPassword = async (password) => {
    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.put(
        'https://sydney-backend.vercel.app/api/v1/users/password',
        { payload: password },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {

        if (response.data.error === null) {
          console.log(response)
          console.log('new password set successfully!');
          return true;
        }

        else {
          toast.error(response.data.error.message, {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
          return false;
        }
      } else {
        console.error('Error in setting new password:', response.data);
      }
    } catch (error) {
      console.error('Error in setting new password:', error);
    }
  };


  const profile = async () => {
    accessToken = localStorage.getItem('accessToken');
    try {
      const response = await axios.get(
        'https://sydney-backend.vercel.app/api/v1/profiles?favourites=true',
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('profile fetched successfully!');
        const siteIds = response.data.sites.map(site => site.id);
        const userData = {
          firstName: response.data.first_name,
          lastName: response.data.last_name,
          image_url: response.data.avatar_url,
          sites: siteIds,
        };
        setUser(userData);
        localStorage.setItem('userData', JSON.stringify(userData));
        return userData;

      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('Error fetching profile data:', error);
    }
  };

  const addFavourite = async (site_id) => {
    accessToken = localStorage.getItem('accessToken');
    try {
      const response = await axios.post(
        'https://sydney-backend.vercel.app/api/v1/profiles/favourite',
        { payload: site_id },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('fav added successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('fav fail to be added', error);
    }
  };

  const deleteFavourite = async (placeId) => {
    accessToken = localStorage.getItem('accessToken');
    try {
      const response = await axios.delete(
        `https://sydney-backend.vercel.app/api/v1/profiles/favourite/${placeId}`,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('fav deleted successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('Failed to delete favorite', error);
    }
  };

  const getFavourite = async () => {
    accessToken = localStorage.getItem('accessToken');
    try {
      const response = await axios.get(
        `https://sydney-backend.vercel.app/api/v1/profiles/favourite`,

        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('fav get successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('Failed to get favorite', error);
    }
  };


  const confirmSignUp = async (tokenHash) => {

    if (tokenHash) {
      try {
        const response = await axios.post("https://sydney-backend.vercel.app/auth/v1/confirm",
          {
            payload: {
              type: 'email',
              token_hash: tokenHash
            }

          }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (response.status === 200) {
          console.log('Confirmation successful');
          localStorage.setItem('accessToken', response.data.data.session.access_token);
          setToken(response.data.data.session.access_token);
          return true;

        } else {
          console.error('Confirmation failed');
        }
      } catch (error) {
        console.error('Error confirming:', error);
      }
    }
  };

  const deleteProfile = async () => {
    accessToken = localStorage.getItem('accessToken');
    try {
      const response = await axios.delete(
        `https://sydney-backend.vercel.app/api/v1/profiles`,

        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('profile deleted successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('fail to delete profile', error);
    }
  };

  const addreview = async (placeID, review) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.post(
        `https://sydney-backend.vercel.app/api/v1/reviews/${placeID}`,
        {
          payload: {
            review: review,
          },
        },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log(response);
        console.log('review added successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('review failed to be added', error);
      // throw error; // throw the error for further handling if needed
    }
  };

  const getReviews = async (placeID) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.get(
        `https://sydney-backend.vercel.app/api/v1/reviews/site/${placeID}`,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response.data[0].review);
        console.log('review fetched successfully!');
        return response;
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('reviews failed to be fetched', error);
      // throw error; // throw the error for further handling if needed
    }
  };


  const deleteReview = async (reviewID) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.delete(
        `https://sydney-backend.vercel.app/api/v1/reviews/${reviewID}`,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        console.log('Review deleted successfully!');
      } else {
        console.error('Error deleting review:', response.data);
      }
    } catch (error) {
      console.error('Failed to delete review', error);
    }
  };



  const updatereview = async (newReview, reviewID) => {
    try {
      const accessToken = localStorage.getItem('accessToken');

      const response = await axios.put(
        `https://sydney-backend.vercel.app/api/v1/reviews/${reviewID}`,
        {
          payload: {
            review: newReview,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        console.log('review updated successfully!', response.data);
        // Handle success, if needed
      } else {
        console.error('Error updating review:', response);
        // Handle error, if needed
      }
    } catch (error) {
      console.error('Error updating review:', error);
    }
  };
  const addrate = async (placeID, rate) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.post(
        `https://sydney-backend.vercel.app/api/v1/reviews/rate/${placeID}`,
        {
          payload: {
            rate: rate,
          },
        },
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        console.log(response);
        console.log('rate added successfully!');
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('rate failed to be added', error);
      // throw error; // throw the error for further handling if needed
    }
  };
  const getrate = async (placeID) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.get(
        `https://sydney-backend.vercel.app/api/v1/reviews/rate/${placeID}`,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        // console.log(response.data[0].rate);
        console.log('rate fetched successfully!');
        return response;
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('rate failed to be fetched', error);
      // throw error; // throw the error for further handling if needed
    }
  };
  const getAverageRate = async (placeID) => {
    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.get(
        `https://sydney-backend.vercel.app/api/v1/reviews/averageRate/${placeID}`,
        {
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        // console.log(response.data[0].rate);
        console.log('average rate fetched successfully!');
        return response;
      } else {
        console.error('error', response.data);
      }
    } catch (error) {
      console.error('average rate failed to be fetched', error);
      // throw error; // throw the error for further handling if needed
    }
  };




  const uploadProfile = async (formData) => {
    const accessToken = localStorage.getItem('accessToken');
    const API_HOST = `https://sydney-backend.vercel.app`;

    try {
      const uploadResponse = await fetch(`${API_HOST}/storage/v1/profile`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (uploadResponse.ok) {
        console.log('Profile uploaded successfully!');
      } else {
        const errorData = await uploadResponse.json();
        console.error('Error uploading profile:', errorData);
      }
    } catch (error) {
      console.error('Failed to upload profile:', error);
    }
  };

  const refreshToken = async (refreshToken) => {
    try {
      const refreshResponse = await axios.post(
        "https://sydney-backend.vercel.app/auth/v1/refresh",
        {
          refresh_token: refreshToken
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (refreshResponse.status === 200) {
        console.log('Token refreshed successfully');
        const newAccessToken = refreshResponse.data.data.session.access_token;
        localStorage.setItem('accessToken', newAccessToken);
        localStorage.setItem('refreshToken', refreshResponse.data.data.session.refresh_token);
        localStorage.setItem('exDate', refreshResponse.data.data.session.expires_in);
        setToken(newAccessToken);
        return newAccessToken;
      } else {
        console.error('Token refresh failed');
        return null;
      }
    } catch (refreshError) {
      console.error('Error refreshing token:', refreshError);
      return null;
    }
  };

  const updateProfile = async (firstName, lastName) => {
    try {
      const accessToken = localStorage.getItem('accessToken');

      const response = await axios.put(
        'https://sydney-backend.vercel.app/api/v1/profiles',
        {
          payload: {
            first_name: firstName,
            last_name: lastName,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        console.log('Profile updated successfully!', response.data);
        // Handle success, if needed
      } else {
        console.error('Error updating profile:', response);
        // Handle error, if needed
      }
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const refreshBeforeExpiration = async (refreshToken, expiresIn) => {
    const oneDayInSeconds = 24 * 60 * 60;
    let refreshTime = expiresIn - oneDayInSeconds; // Time to refresh before expiration

    const updateRefreshTime = () => {
      if (refreshTime > 0) {
        const remainingDays = Math.ceil(refreshTime / oneDayInSeconds);
        const remainingHours = Math.floor((refreshTime % oneDayInSeconds) / (60 * 60));

        console.log(`Token will be refreshed in ${remainingDays} day(s) and ${remainingHours} hour(s).`);


        const nextDayRefreshTime = refreshTime % oneDayInSeconds === 0 ? oneDayInSeconds : refreshTime % oneDayInSeconds;

        setTimeout(() => {
          refreshTime -= nextDayRefreshTime;
          updateRefreshTime();
        }, nextDayRefreshTime * 1000);
      } else {
        console.log('Token has already expired or will expire very soon.');
      }
    };

    updateRefreshTime();


    setTimeout(async () => {
      try {
        const newAccessToken = await refreshToken(refreshToken);
        if (newAccessToken) {
          console.log('Token refreshed successfully before expiration.');
        } else {
          console.error('Token refresh failed.');
        }
      } catch (error) {
        console.error('Error refreshing token:', error);
      }
    }, refreshTime * 1000);
  };













  return (

    <AuthContext.Provider value={{
      isAuthenticated: state.isAuthenticated, accessToken: state.accessToken, userData: state.userData,
      signup, login, signout, sendConfirmationEmail, checkotp, profile, setNewPassword, addFavourite,
      deleteFavourite, getFavourite, confirmSignUp, deleteProfile, refreshToken, refreshBeforeExpiration,
      uploadProfile, addreview, getReviews, deleteReview, updatereview, addrate, getrate, getAverageRate, updateProfile
    }}>

      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);